import { PRICING_PAGE } from "@/lib/constants";
import { Button } from "@/components/ui/button";
import { Check } from "lucide-react";

export default function ProfessionalSetup() {
  const { professionalSetup } = PRICING_PAGE;

  return (
    <section
      data-testid="professional-setup-section"
      className="bg-white py-12 md:py-20"
      aria-label="Professional setup"
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-xl">
        <div
          data-testid="setup-card"
          className="bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden"
        >
          {/* Green top border */}
          <div className="h-1 bg-[#20611B]" />

          <div className="p-6 md:p-10">
            {/* Label */}
            <p className="text-xs font-bold uppercase tracking-widest text-[#6B7280] mb-4">
              {professionalSetup.label}
            </p>

            <h3
              className="font-heading text-2xl md:text-3xl font-bold text-[#1A1A1A] tracking-tight mb-4"
              data-testid="setup-heading"
            >
              {professionalSetup.heading}
            </h3>

            <p className="text-[#6B7280] text-base leading-relaxed mb-6">
              {professionalSetup.body}
            </p>

            {/* Checklist */}
            <div className="space-y-3 mb-6">
              {professionalSetup.checklist.map((item, i) => (
                <div
                  key={i}
                  className="flex items-center gap-2.5"
                  data-testid={`setup-item-${i}`}
                >
                  <span className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-[#D8FFB8] shrink-0">
                    <Check className="h-3 w-3 text-[#20611B]" />
                  </span>
                  <span className="text-sm text-[#1A1A1A]">{item}</span>
                </div>
              ))}
            </div>

            {/* Price */}
            <div className="mb-6">
              <span className="font-heading text-3xl font-extrabold text-[#1A1A1A]">
                {professionalSetup.price}
              </span>
              <span className="text-base text-[#6B7280] ml-2">
                {professionalSetup.priceSuffix}
              </span>
            </div>

            {/* CTA - secondary style (green) */}
            <Button
              data-testid="setup-cta"
              className="w-full bg-[#20611B] hover:bg-[#174d14] text-white font-bold h-12 rounded-md shadow-sm hover:shadow-md transition-all active:scale-95 text-sm tracking-wide"
            >
              {professionalSetup.cta}
            </Button>
            <p className="text-xs text-[#6B7280] text-center mt-3">
              {professionalSetup.ctaSubtext}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
